import React from "react";
import { useDispatch } from "react-redux";

import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

import { useEffect } from "react";
import PrimaryButton from "../../../../Components/UI/Buttons/PrimaryButton";
import SecondaryButton from "../../../../Components/UI/Buttons/SecondaryButton";
import { uploadMedia } from "../../../../Stores/HubBlog/actions";
import flexStyles from "../../../../style/flex";
import { useStyles } from "../style";
import DocumentCard from "./DocumentCard";

function DocumentModal({ open, onClose, id, images }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const flexClasses = flexStyles();
  const [media, setMedia] = React.useState([]);

  const onDelete = (indexToDelete) => {
    let tempList = [...media];
    tempList.splice(indexToDelete, 1);
    setMedia(tempList);
  };

  const handleUpdate = (index, key, value) => {
    let tempList = [...media];
    tempList[index][key] = value;
    setMedia(tempList);
  };

  const onSave = () => {
    const bodyFormData = new FormData();
    bodyFormData.append(`company_blog_id`, id);

    if (media?.length > 0) {
      media.map((item, index) => {
        if (item.file || item.id) {
          bodyFormData.append(`images[${index}][id]`, item?.id ?? "");
          bodyFormData.append(`images[${index}][file]`, item?.file ?? "");
          bodyFormData.append(
            `images[${index}][is_gallery]`,
            item.is_gallery ?? false
          );
        }
      });
    }
    dispatch(uploadMedia({ data: bodyFormData, id }));
    onClose();
  };

  useEffect(() => {
    if (images?.length > 0) {
      setMedia(JSON.parse(JSON.stringify(images)));
    } else {
      setMedia([]);
    }
  }, [images, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth={true}>
      <DialogTitle className={classes.titleStyle}>Document</DialogTitle>
      <DialogContent className={classes.descStyle}>
        <Box className={flexClasses.flexContainer}>
          {media.length > 0 ? (
            media.map((item, index) => (
              <Box className={flexClasses.itemMD} key={index} index={index}>
                <DocumentCard
                  data={item}
                  index={index}
                  onDelete={(indexToDelete) => onDelete(indexToDelete)}
                  handleUpdate={(...args) => handleUpdate(...args)}
                />
              </Box>
            ))
          ) : (
            <Box className={flexClasses.itemMD}>
              <Typography>No Media File(s)</Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
        <PrimaryButton
          onClick={() => {
            setMedia([...media, { file: null, is_gallery: false }]);
          }}
        >
          Add Media
        </PrimaryButton>
        <PrimaryButton hideIcon={true} onClick={() => onSave()}>
          Save
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

export default DocumentModal;
